import { render } from "./DocumentationList.vue?vue&type=template&id=6d6067c8&scoped=true"
import script from "./DocumentationList.vue?vue&type=script&lang=js"
export * from "./DocumentationList.vue?vue&type=script&lang=js"

import "./DocumentationList.vue?vue&type=style&index=0&id=6d6067c8&scoped=true&lang=scss"

import exportComponent from "/Users/dmitriy-pc/Projects/ds-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d6067c8"]])

export default __exports__